import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { palette } from '../../../system/styles/styles';
import Save from '../../../system/access/images/ats/save.png';
import Applicant from './applicant';
import Pupop from './popup';
import { updateNameColumn } from '../../../redux/actions/backendActions';

const MainContainer = styled.main`
  height: calc(100% - 5px);
  ._title {
    display: grid;
    grid-template-columns: calc(100% - 25px) 25px;
    margin: 0px;
    align-items: center;
  }
  ._title img {
    width: 20px;
    height: 20px;
  }
  ._title button {
    background-color: transparent;
    max-width: 25px;
    min-width: 25px;
    height: 25px;
    align-items: center;
    justify-content: center;
    padding: 0px;
    cursor: pointer;
  }
  .changedName {
    width: 100%;
    display: flex;
    gap: 10px;
    marign-top: 10px;
  }
  .changedName input {
    width: 80%;
    font-size: 16px;
    background-color: transparent;
    border: none;
    border-bottom: solid #ccc 1px;
    transition: 0.3s;
    &:focus {
      outline: none;
      transition: 0.3s;
      border-bottom: solid ${palette.black} 1px;
    }
    &:active {
      outline: none;
    }
  }
  .changedName button {
    width: calc(20% - 10px);
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    cursor: pointer;
    &:active {
      outline: none;
    }
    &:focus {
      outline: none;
    }
  }
  .changedName img {
    width: 20px;
    height: 20px;
    max-width: inherit;
  }
  .scroll {
    max-width: 290px;
    min-width: 290px;
    padding: 14px;
    &::-webkit-scrollbar {
      width: 0.75em;
      height: 0.5em;
    }
    &::-webkit-scrollbar-track {
      background-color: #f2f2f2;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 0.5rem;
    }
    overflow-y: auto;
    overflow-x: hidden;
  }
`;

const DroppableContainer = (props) => {
  const {
    candidates,
    value,
    column_names,
    changeColumnEditor,
    deleteCanidates_View,
    onOpenModal,
    columnNameEditor,
    userData,
    closeName,
    index,
    data,
    uid,
    idVacancy,
    Open_ClosedModal,
    comboBox_Fuction,
  } = props;
  const { t } = useTranslation(['ats']);
  const dispatch = useDispatch();
  const load = useSelector((state) => state.backend?.vacancy?.load);
  const [state, setState] = React.useState({
    candidates_total_uni: [],
    nameColumn: {
      id: '',
      name: '',
    },
  });
  const onUpdateNameColumnOn = async (data) => {
    if (state.nameColumn.name.length === 0) {
      NotificationManager.error('Nombre no valido', '', 3000);
      const temp = state.boxes;
      setState(
        (prev) => ({
          ...prev,
          columnNameEditor: '',
          boxes: [],
        }),
        () => {
          setState((prev) => ({ ...prev, boxes: temp }));
        }
      );
      return;
    }
    const {name} = state.nameColumn;
    dispatch(updateNameColumn({ uid, url: idVacancy, data, name }));
    closeName();
  };
  const update_name = (id, value) => {
    // const { id, value } = e.target;
    const nameColumn = {
      name: value,
      id,
    };
    setState((prev) => ({
      ...prev,
      nameColumn,
    }));
  };

  React.useEffect(() => {
    const va_can = value.candidates;
    if (va_can) {
      const array_column_candidate = [];
      candidates.map((e, index) => {
        const decition = va_can.filter((o) => o.idUser === e.docID);
        if (decition.length > 0) {
          e.sortIndex = decition[0].sortIndex;
          array_column_candidate.push(e);
        }
      });
      // console.log(array_column_candidate)
      setState((prevState) => ({
        ...prevState,
        candidates_total_uni: array_column_candidate.sort((a, b) => a.sortIndex - b.sortIndex),
      }));
      // console.log(array_column_candidate)
    } else {
      setState((prevState) => ({ ...prevState, candidates_total_uni: [] }));
    }
  }, [value, column_names, load]);
  return (
    <MainContainer>
      <div
        style={{
          marginBottom: 16,
          paddingTop: 14,
          paddingLeft: 14,
          paddingRight: 14,
        }}>
        {(column_names || []).map((name, index) => {
          if (name.docID === value.docID) {
            let nom;
            let boolName = true;
            switch (name.name) {
              case 'Aceptado(s)':
                nom = 'Accepted';
                boolName = false;
                break;
              case 'Rechazados':
                nom = 'Rejected';
                boolName = false;
                break;
              case 'Filtro Personal 1':
                nom = 'PersonalFilter1';
                break;
              case 'Filtro Personal 2':
                nom = 'PersonalFilter2';
                break;
              case 'Sin Nombre':
                nom = 'Unnamed';
                break;
              default:
                nom = name.name;
            }

            return (
              <div key={index.toString()} className="_title">
                <h4
                  key={index.toString()}
                  style={{
                    marginBottom: '10px',
                  }}>
                  {' '}
                  {t(nom)}{' '}
                </h4>
                {boolName ? (
                  <Pupop
                    id={value.docID}
                    inputcheck={value.check_multi}
                    onEdit={changeColumnEditor}
                    onRemove={deleteCanidates_View}
                    edit={Boolean(
                      index === data.length - 1 || index === data.length - 2 || data.name == 'Filtro Automatico'
                    )}
                    sendable={{
                      id: value.docID,
                      uid,
                      idVacancy,
                    }}
                    open={onOpenModal}
                  />
                ) : null}
              </div>
            );
          }
          return null;
        })}
        {/* {!tmp ? <h4 key={index}>{t("Unnamed")}</h4> : null} */}
        {index === data.length - 2 ? <p style={{ fontSize: 12 }}>{t('RejectedWillBeNotified')}</p> : null}
        {columnNameEditor === value.docID ? (
          <div className="changedName">
            <input
              id={value.docID}
              type="text"
              placeholder={t('NewName')}
              onChange={(e) => update_name(value.docID, e.target.value)}
            />
            <button type="button" onClick={() => onUpdateNameColumnOn(value.docID)}>
              <img src={Save} alt="Guardar" />
            </button>
          </div>
        ) : null}
      </div>
      <Droppable key={value.docID} droppableId={value.docID}>
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className="scroll"
            style={{
              height: 'calc(94vh - 157px)',
            }}>
            {
              // console.log(value.candidates)
              state.candidates_total_uni.map((canidate, idx) => {
                return (
                  <Draggable key={`${canidate.time}_${idx}`} draggableId={`${canidate.time}_${idx}`} index={idx}>
                    {(provided, snapshot) => (
                      <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                        <Applicant
                          comboBox_Fuction={comboBox_Fuction}
                          inputcheck={value.check_multi}
                          idColumn={value.docID}
                          _column={index + 1}
                          data={userData}
                          info={canidate}
                          // setDownload={setViewed}
                          key={`${canidate.names}_${idx}`}
                          // _sendComment={sendComment}
                          // updateComment={updateComment}
                          // _postStar={postStar}
                          // idVacancy={idVacancy}
                          Open_ClosedModal={Open_ClosedModal}
                          // _updateStar={updateStar}
                          // Load_Save={Load_Save}
                        />
                      </div>
                    )}
                  </Draggable>
                );
              })
            }
          </div>
        )}
      </Droppable>
    </MainContainer>
  );
};

export default DroppableContainer;
